/**
 * ============================================================
 * KEJJA OS — src/components/ThemePicker.tsx
 * ============================================================
 */

import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, type Theme } from '@/hooks/useTheme';
import { cn } from '@/lib/utils';

const OPTIONS: Array<{ value: Theme; label: string; icon: typeof Sun }> = [
  { value: 'light',  label: 'Light',  icon: Sun },
  { value: 'dark',   label: 'Dark',   icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
];

export default function ThemePicker() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex gap-1.5">
      {OPTIONS.map((opt) => {
        const Icon = opt.icon;
        const active = theme === opt.value;
        return (
          <button
            key={opt.value}
            onClick={() => setTheme(opt.value)}
            className={cn(
              'flex-1 flex flex-col items-center justify-center gap-1 py-3 rounded-md border transition-colors',
              active
                ? 'border-sky-500/60 bg-sky-500/10 text-sky-700 dark:text-sky-300'
                : 'border-border text-muted-foreground hover:bg-muted',
            )}
          >
            <Icon className="w-4 h-4" />
            <span className="text-[11px] font-medium">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
